var _path, _circle, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHideInformation = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.94 11.72C21 10.41 16.92 5 12 5s-9 5.41-9.94 6.72a.45.45 0 0 0 0 .56C3 13.59 7.08 19 12 19s9-5.41 9.94-6.72a.45.45 0 0 0 0-.56ZM12 17a5 5 0 1 1 5-5 5 5 0 0 1-5 5Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 3
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 23.04,
  x: 10.5,
  y: 0.48,
  rx: 0.5,
  transform: "rotate(-135 12 12)"
})));
export default SvgHideInformation;